export const depths = { '0-20': '0-20 cm', '20-40': '20-40 cm' };

export const perDepthValues = {
  density: 'Densidad Aparente (g/cm3 o tn/m3)',
  MO: 'Materia Orgánica (%)',
  CO: 'Carbono Orgánico (%)',
  Nt: 'Nitrogeno Total (%)',
  RelatCN: 'Relacion C/N',
  pH: 'pH',
  CE: 'Conductividad Eléctrica (dS/m)',
  NO3: 'Nitratos (ppm)',
  N_NO3: 'Nitrogeno de Nitratos (ppm)',
  P: 'Fósforo Extraíble (ppm)',
  S: 'Azufre de Sulfatos (u/g)',
  CaCIC: 'Calcio (meq/100g)',
  Ca: 'Calcio (ppm)',
  MgCIC: 'Magnesio (meq/100g)',
  Mg: 'Magnesio (ppm)',
  NaCIC: 'Sodio (meq/100g)',
  Na: 'Sodio (ppm)',
  KCIC: 'Potasio (meq/100g)',
  K: 'Potasio (ppm)',
  SaturacionBases: 'Saturación de Bases (meq/100g)',
  CIC: 'CIC (meq/100g)',
  SaturacionBasesPorc: 'Sat. de Bases [SB / CIC * 100] (%)'
};

export const fertilizers = {
  urea: 'Urea | 46-0-0',
  nitratoNh4: 'Nitrato de Amonio | 33-0-0',
  nacs: 'NACS | 24-0-0 (6S - 6Ca - 4Mg)',
  aa: 'Amoníaco Anhidro | 87-0-0',
  uan: 'UAN | 32-0-0',
  solMix: 'SolMix | 32-0-0 (3S)',
  map: 'MAP | 11-52-0',
  dap: 'DAP | 18-46-0',
  nitratoK: 'Nitrato de Potasio | 13-0-44',
  sulfatoNh4: 'Sulfato de Amonio | 21-0-0 (24S)',
  sulfonitrato: 'Sulfonitrato | 26-0-0 (14S)',
  sulfan: 'Sulfan | 24-0-0 (6S - 11Ca)',
  sps: 'Superfosfato Simple (SPS) | 0-20-0 (12S - 20Ca)',
  spt: 'Superfosfato Triple (SPT) | 0-46-0 (14S)',
  no3k: 'Nitrato de Potasio (NO3 K) | 0-0-45',
  clk: 'Cloruro de Potasio (KCl) | 0-0-60',
  sulfatoK: 'Sulfato de Potasio | 0-0-50 (18S)',
  canS: 'CAN-S | 24-0-0 (6S - 11Ca)',
  sMg: 'Sulfato de Magnesio | 0-0-0 (18S - 22Mg)',
  nitroDoble: 'Nitro Doble | 27-0-0 (6Ca - 4Mg)',
  nitrocomplex: 'Nitrocomplex | 21-17-3 (4S - 1Mg)',
  hydrocomplex: 'Hydrocomplex | 12-11-18 (8S - 4Ca - 3Mg)',
  microEssentialsSZ: 'MicroEssentials SZ | 12-40-0 (10S)',
  microEssentialsS9: 'MicroEssentials S9 | 10-46-0 (9S)',
  topika: 'Topika | 13-0-46',
  sausor: 'Sausor | 3-30-0 (6S - 22Ca)',
  rega: 'Rega | 20-5-17 (2Mg)',
  microstar: 'Microstar | 10-40-0 (10S)',
  basifertilPlus: 'Basifertil Plus | 3-18-0 (10S - 14Ca - 2Mg)',
  basifertilAzote: 'Basifertil Azote | 20-10-0 (7S - 5Ca)',
  basifertilKent: 'Basifertil Kent | 5-12-8 (9S - 12Ca)',
  sulfano22: 'Sulfamo 22 | 22-0-0 (5S - 10Ca - 2Mg)',
  sulfano29: 'Sulfamo 29 | 29-0-0 (7S - 5Ca - 2Mg)',
  topPhos118: 'Top Phos 118 | 0-18-0 (11S - 18Ca)',
  topPhos280: 'Top Phos 280 | 1-28-0 (5S - 17Ca)',
  mezclaQuimica: 'Mezcla Química | 12-40-0 (5S)',
};